// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Grid,
//   Typography,
//   IconButton,
//   Box,
// } from "@mui/material";
// import { useEffect, useState } from "react";
// import CloseIcon from "@mui/icons-material/Close";
// import { Loader } from "../../components/CustomLoader";
// import { userServices } from "../../services/AllServices";
// import errorHandler from "../../utils/errorHandler";
// import { capitalize } from "../../utils/helpers";
// import { IMAGE_BASE } from "../../utils/constants";

// const UserField = ({ label, value }) => (
//   <Box sx={{ mb: 2 }}>
//     <Typography variant="subtitle2" color="text.secondary">
//       {label}
//     </Typography>
//     <Typography variant="body1" sx={{ mt: 0.5 }}>
//       {value}
//     </Typography>
//   </Box>
// );

// const ViewUserManagement = ({ id, show, onHide }) => {
//   const [data, setData] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [openImageModal, setOpenImageModal] = useState(false);

//   const userData = async () => {
//     try {
//       setLoading(true);
//       const response = await userServices.getById({ id: id });
//       setData(response.data.data);
//     } catch (error) {
//       errorHandler(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (show) userData();
//   }, [show]);

//   return (
//     <>
//       <Dialog maxWidth="md" fullWidth open={show} onClose={onHide}>
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             fontWeight: 600,
//             fontSize: "1.4rem",
//           }}
//         >
//           User Details
//           <IconButton onClick={onHide}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         {loading ? (
//           <Loader />
//         ) : (
//           <DialogContent dividers sx={{ p: 4 }}>
//             <Grid container spacing={4}>
//               {/* Left Column */}
//               <Grid item xs={12} md={6}>
//                 <UserField label="Full Name" value={capitalize(data?.fullName)} />
//                 <UserField label="Email" value={capitalize(data?.email)} />
//                 {data?.phoneNumber && <UserField label="Phone Number" value={data.phoneNumber} />}
//                 {data?.useraddress?.address && (
//                   <UserField
//                     label="Address"
//                     value={capitalize(data?.useraddress?.address)}
//                   />
//                 )}
//                 <UserField
//                   label="Status"
//                   value={capitalize(data?.status === 1 ? "Active" : "Inactive")}
//                 />
//               </Grid>

//               {/* Right Column - Document */}
//               {data?.document && (
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                     Document
//                   </Typography>
//                   <Box
//                     component="img"
//                     src={IMAGE_BASE + data.document}
//                     alt="Document"
//                     onClick={() => setOpenImageModal(true)}
//                     sx={{
//                       width: "100%",
//                       maxWidth: "300px",
//                       borderRadius: 2,
//                       cursor: "pointer",
//                       boxShadow: 3,
//                       transition: "transform 0.3s",
//                       "&:hover": {
//                         transform: "scale(1.02)",
//                       },
//                     }}
//                   />
//                 </Grid>
//               )}
//             </Grid>

//             <DialogActions sx={{ mt: 4 }}>
//               <Button variant="contained" onClick={onHide} sx={{ borderRadius: 2 }}>
//                 Close
//               </Button>
//             </DialogActions>
//           </DialogContent>
//         )}
//       </Dialog>

//       {/* Image Modal */}
//       <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="md">
//         <DialogTitle
//           sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
//         >
//           Image Preview
//           <IconButton onClick={() => setOpenImageModal(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Box
//             component="img"
//             src={IMAGE_BASE + data?.document}
//             alt="Preview"
//             sx={{ width: "100%", height: "auto", borderRadius: 2 }}
//           />
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default ViewUserManagement;




import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Loader } from "../../components/CustomLoader";
import { userServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import { IMAGE_BASE } from "../../utils/constants";

const ViewUserManagement = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const [openImageModal, setOpenImageModal] = useState(false);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await userServices.getById({ id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) userData();
  }, [show]);

  return (
    <>
      <Dialog open={show} onClose={onHide} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1.4rem",
            fontWeight: 600,
            pb: 0,
          }}
        >
          User Information
          <IconButton onClick={onHide}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {loading ? (
          <Loader />
        ) : (
          <DialogContent dividers sx={{ p: 0 }}>
            <Paper elevation={0} sx={{ p: 4 }}>
              <Grid container spacing={4}>
                {/* User Details */}
                <Grid item xs={12} md={7}>
                  <Detail label="Full Name" value={capitalize(data?.firstName) +' '+ data?.lastName} />
                  <Detail label="Email" value={data?.email} />
                  {data?.phoneNumber && (
                    <Detail label="Phone Number" value={data?.phoneNumber} />
                  )}
                  {data?.useraddress?.address && (
                    <Detail
                      label="Address"
                      value={capitalize(data?.useraddress?.address)}
                    />
                  )}
                  <Detail
                    label="Status"
                    value={data?.status === 1 ? "Active" : "Inactive"}
                  />
                </Grid>

                {/* Image Section */}
                <Grid
                  item
                  xs={12}
                  md={5}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {data?.document ? (
                    <>
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        Uploaded Document
                      </Typography>
                      <Box
                        component="img"
                        src={IMAGE_BASE + data.document}
                        alt="Document"
                        onClick={() => setOpenImageModal(true)}
                        sx={{
                          width: "100%",
                          maxWidth: "260px",
                          borderRadius: 2,
                          boxShadow: 3,
                          cursor: "pointer",
                          transition: "0.2s",
                          "&:hover": {
                            transform: "scale(1.03)",
                          },
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No document uploaded
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <DialogActions sx={{ mt: 4, justifyContent: "flex-end" }}>
                <Button variant="contained" onClick={onHide} sx={{ borderRadius: 2 }}>
                  Close
                </Button>
              </DialogActions>
            </Paper>
          </DialogContent>
        )}
      </Dialog>

      {/* Image Preview Modal */}
      <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="md">
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Document Preview
          <IconButton onClick={() => setOpenImageModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            component="img"
            src={IMAGE_BASE + data?.document}
            alt="Preview"
            sx={{ width: "100%", borderRadius: 2 }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

const Detail = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontWeight: 500, letterSpacing: 0.5 }}
    >
      {label.toUpperCase()}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      {value || "--"}
    </Typography>
  </Box>
);

export default ViewUserManagement;
